<template>
    <svg
        version="1.1"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px"
        viewBox="0 0 477.867 477.867"
        style="enable-background:new 0 0 477.867 477.867;">
        <g>
            <path d="M392.533,0h-307.2C38.228,0.056,0.056,38.228,0,85.333v307.2c0.056,47.105,38.228,85.277,85.333,85.333h307.2
                c47.105-0.056,85.277-38.228,85.333-85.333v-307.2C477.81,38.228,439.638,0.056,392.533,0z M422.571,215.911
                c-0.571,0.667-1.193,1.289-1.86,1.86l-119.467,102.4c-7.155,6.136-17.929,5.31-24.065-1.844
                c-2.657-3.098-4.116-7.045-4.112-11.126V256h-102.4c-9.426,0-17.067-7.641-17.067-17.067v-27.051l-61.201,61.184l61.201,61.201
                V307.2c0-9.426,7.641-17.067,17.067-17.067h51.2c9.426,0,17.067,7.641,17.067,17.067s-7.641,17.067-17.067,17.067h-34.133v51.2
                c0.002,6.902-4.154,13.126-10.53,15.77c-2.071,0.863-4.293,1.304-6.537,1.297c-4.524,0.004-8.863-1.789-12.066-4.983l-102.4-102.4
                c-6.669-6.661-6.675-17.467-0.013-24.136c0.004-0.004,0.009-0.009,0.013-0.013l102.4-102.4c6.666-6.664,17.472-6.662,24.136,0.004
                c3.199,3.2,4.996,7.538,4.997,12.063v51.2h102.4c9.426,0,17.067,7.641,17.067,17.067v31.181l76.169-65.314L307.2,139.52v31.147
                c0,9.426-7.641,17.067-17.067,17.067h-51.2c-9.426,0-17.067-7.641-17.067-17.067s7.641-17.067,17.067-17.067h34.133v-51.2
                c0.001-9.426,7.642-17.066,17.068-17.065c4.075,0,8.016,1.459,11.109,4.112l119.467,102.4
                C427.869,197.978,428.702,208.752,422.571,215.911z">
            </path>
        </g>
    </svg>

<!--    <svg -->
<!--        version="1.1"-->
<!--        xml:space="preserve"-->
<!--        xmlns="http://www.w3.org/2000/svg"-->
<!--        xmlns:xlink="http://www.w3.org/1999/xlink"-->
<!--        x="0px" y="0px"-->
<!--        viewBox="0 0 477.859 477.859"-->
<!--        style="enable-background:new 0 0 477.859 477.859;">-->
<!--        <g>-->
<!--            <path d="M472.863,175.662L353.396,56.195c-6.666-6.664-17.472-6.662-24.136,0.004c-3.199,3.2-4.996,7.538-4.997,12.063v51.2-->
<!--                H204.796c-9.426,0-17.067,7.641-17.067,17.067c0,9.426,7.641,17.067,17.067,17.067H341.33c9.426,0,17.067-7.641,17.067-17.067-->
<!--                V109.46l78.268,78.268l-78.268,78.268v-27.068c0-9.426-7.641-17.067-17.067-17.067H153.596v-51.2-->
<!--                c-0.002-9.426-7.645-17.065-17.07-17.063c-4.524,0.001-8.863,1.798-12.063,4.997L4.997,278.062-->
<!--                c-6.663,6.665-6.663,17.468,0,24.132l119.467,119.467c3.2,3.201,7.54,5,12.066,5.001c2.243,0.007,4.466-0.434,6.536-1.297-->
<!--                c6.376-2.644,10.532-8.867,10.53-15.77v-51.2h119.467c9.426,0,17.067-7.641,17.067-17.067s-7.641-17.067-17.067-17.067H136.53-->
<!--                c-9.426,0-17.067,7.641-17.067,17.067v27.068l-78.268-78.268l78.268-78.268v27.068c0,9.426,7.641,17.067,17.067,17.067h187.733-->
<!--                v51.2c0.002,9.426,7.645,17.065,17.07,17.063c4.524-0.001,8.863-1.798,12.063-4.997l119.467-119.467-->
<!--                C479.525,193.129,479.525,182.326,472.863,175.662z">-->
<!--            </path>-->
<!--        </g>-->
<!--    </svg>-->

<!--    <svg-->
<!--        version="1.1"-->
<!--        xml:space="preserve"-->
<!--        xmlns="http://www.w3.org/2000/svg"-->
<!--        xmlns:xlink="http://www.w3.org/1999/xlink"-->
<!--        x="0px" y="0px"-->
<!--        viewBox="0 0 512 512"-->
<!--        style="enable-background:new 0 0 512 512;">-->
<!--        <path d="M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 -->
<!--            33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 -->
<!--            80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z">-->
<!--        </path>-->
<!--    </svg>-->

</template>

<script>
    export default {}
</script>

<style scoped>

</style>
